import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import CommentIcon from "@mui/icons-material/Comment";
import IconButton from "@mui/material/IconButton";
import {
  Collapse,
  ListItemButton,
  ListItemIcon,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
import { categoryApi, serviceCategoryApi } from "../API/Api";
import { useRef } from "react";
import { Box, Stack } from "@mui/material";
import { KeyboardArrowDown, StarBorder } from "@mui/icons-material";
import "./CategoryList.css";

const decodeLocalData = (name) => {
  let result = atob(window.localStorage.getItem(name));
  return JSON.parse(result);
};
const CategoryList = ({ setServiceListData, page, setFirstLoadIndicator,
   sourceValueId, setSourceValueId,
   source, 
   setSource
  }) => {
  // let localData = decodeLocalData("gh_sl@g");

  const focus = useRef(null);
  const [toggle, setToggle] = useState(true);
  const [categoryHeight, setCategoryHeight] = useState("");
  const [categoryListData, setCategoryListData] = useState([]);
  const [subCategoryMap, setSubCategoryMap] = useState({});
  const [openCategoryId, setOpenCategoryId] = useState(null);



  // 1️⃣ Fetch category list on mount
  useEffect(() => {
    fetch("https://aps.songjukti.com/profile/login/api_service/all_service_category.php")
      .then((res) => res.json())
      .then((result) => setCategoryListData(result))
      .catch((error) => console.log("ServiceApiError=> ", error));
  }, []);

  // 2️⃣ Set height of category container after category list is loaded
  useEffect(() => {
    if (focus.current) {
      setCategoryHeight(focus.current.offsetHeight);
    }
  }, [categoryListData, toggle]);

  // 3️⃣ Fetch service list whenever page, source, or sourceValueId changes
  useEffect(() => {
    if (!sourceValueId) return;

    const formData = new FormData();
    formData.append("pref", sourceValueId);
    formData.append("page", page);

    let endpoint =
      source === "subCategory"
        ? "j_service_sub.php"
        : "j_service_cat.php";

    fetch(`https://aps.songjukti.com/profile/login/api_service/new_24/${endpoint}`, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => {
        setServiceListData(result);
      })
      .catch((error) => console.log("ServiceApiError=> ", error));
  }, [page, source, sourceValueId]);

  const handleSubCategory = (cat_id) => {
    setFirstLoadIndicator(false);

    // Toggle collapse
    const isOpen = openCategoryId === cat_id;
    setOpenCategoryId(isOpen ? null : cat_id);

    if (!isOpen && !subCategoryMap[cat_id]) {
      const formData = new FormData();
      formData.append("category_id", cat_id);

      fetch("https://aps.songjukti.com/profile/login/api_service/all_service_subcategory.php", {
        method: "POST",
        body: formData,
      })
        .then((res) => res.json())
        .then((result) => {
          setSubCategoryMap((prev) => ({ ...prev, [cat_id]: result }));
        })
        .catch((error) => console.log("ServiceApiError=> ", error));
    }

    // Set source to category (in case subcategory is not clicked)
    setSource("category");
    setSourceValueId(cat_id);
  };

  const handleCategoryClick = (cat_id) => {
    setFirstLoadIndicator(false);
    setSource("category");
    setSourceValueId(cat_id);
  };

  const handleSubCategoryClick = (sub_cat_id) => {
    setFirstLoadIndicator(false);
    setSource("subCategory");
    setSourceValueId(sub_cat_id);
  };

  return (
    <Box>
      <Stack direction={"row"} justifyContent="space-between" alignItems="center">
        <Typography variant="p" sx={{ fontSize: "13pt", fontWeight: 600 }}>
          Categories
        </Typography>
        <IconButton size="medium" onClick={() => setToggle(!toggle)}>
          <KeyboardArrowDown
            fontSize="inherit"
            color="black"
            sx={{
              transform: !toggle ? "rotate(-180deg)" : "",
              transition: "transform 1s",
            }}
          />
        </IconButton>
      </Stack>

      <Box
        className={!toggle ? "lowCategoryHeight" : ""}
        sx={{
          height: toggle && categoryHeight ? `${categoryHeight}px !important` : "0px",
          transition: "height 1s",
        }}
      >
        <List sx={{ width: "100%", backgroundColor: "background.paper" }} ref={focus}>
          {categoryListData.map((value) => (
            <React.Fragment key={value.category_id}>
              <ListItem
                disableGutters
                sx={{ padding: 0, cursor: "pointer" }}
                secondaryAction={
                  <IconButton
                    size="small"
                    onClick={() => handleSubCategory(value.category_id)}
                  >
                    <KeyboardArrowDown
                      fontSize="inherit"
                      color="black"
                      sx={{
                        transform:
                          openCategoryId === value.category_id ? "rotate(-180deg)" : "",
                        transition: "transform 0.5s",
                      }}
                    />
                  </IconButton>
                }
              >
                <ListItemText
                  primary={value.category_name}
                  onClick={() => handleCategoryClick(value.category_id)}
                />
              </ListItem>

              <Collapse in={openCategoryId === value.category_id} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {(subCategoryMap[value.category_id] || []).map((sub) => (
                    <ListItem
                      key={sub.subcategory_id}
                      disableGutters
                      sx={{ padding: 0, cursor: "pointer" }}
                    >
                      <ListItemText
                        primary={sub.subcategory_name}
                        sx={{ paddingLeft: "15px" }}
                        onClick={() => handleSubCategoryClick(sub.subcategory_id)}
                      />
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            </React.Fragment>
          ))}
        </List>
      </Box>
    </Box>
  );
};


export default CategoryList;
